export default "assets/images/icons/arrow-0b47d2f4.svg";